// Add your custom JS here.

(function ($) {
    $(document).ready(function () {
        $('.toTop').on('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        $('.openMenu').on('click', function (e) {
            e.preventDefault();
            $('body').addClass('activeMenu');
        });
        $('.closeMenu').on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('activeMenu');
        });

        //slider
        if ($('.bnTop').length) {
            const bnTop = new Swiper(".bnTop", {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                speed: 1000,
                loop: true,
            });
        }

        if ($('.feaHome__slider').length) {
            const feaHome = new Swiper(".feaHome__slider", {
                slidesPerView: 5,
                spaceBetween: 24,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                speed: 1000,
                loop: false,
                rewind: true,
                navigation: {
                    nextEl: ".feaHome__wrap .swiper-button-next",
                    prevEl: ".feaHome__wrap .swiper-button-prev",
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 10
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    // when window width is >= 991px
                    991: {
                        slidesPerView: 5,
                        spaceBetween: 10
                    }
                }
            });
        }

        const previewCtrl = new Swiper(".recentHome__list", {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 5,
            watchSlidesProgress: true,
            direction: "vertical",
        });
        const previewSlider = new Swiper(".recentHome__preview", {
            effect: 'fade',
            loop: true,
            spaceBetween: 10,
            thumbs: {
                swiper: previewCtrl,
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            speed: 300,
        });
        $('.recentHome__preview, .recentHome__list').on('mouseover', function () {
            previewSlider.autoplay.stop();
        }).on('mouseout', function () {
            previewSlider.autoplay.start();
        });

        // Sự kiện hover để thay đổi slider chính
        document.querySelectorAll('.recentHome__list .swiper-slide').forEach(function (thumbnail, index) {
            thumbnail.addEventListener('mouseenter', function () {
                previewSlider.slideTo(index); // Chuyển đến slide tương ứng
            });
        });

        $('.postDetail__content table').wrap('<div class="wrapTable"></div>');
    });
})(jQuery)